import { render, staticRenderFns } from "./fileDetail.vue?vue&type=template&id=15f3c043&scoped=true&"
import script from "./fileDetail.vue?vue&type=script&lang=js&"
export * from "./fileDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f3c043",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f3c043')) {
      api.createRecord('15f3c043', component.options)
    } else {
      api.reload('15f3c043', component.options)
    }
    module.hot.accept("./fileDetail.vue?vue&type=template&id=15f3c043&scoped=true&", function () {
      api.rerender('15f3c043', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/answer/commonFile/fileDetail.vue"
export default component.exports